
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 512 512","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M464 258.2c0 2.7-1 5.2-4.2 8-3.8 3.1-10.1 5.8-17.8 5.8h-98c-53 0-96 43-96 96 0 6.8.7 13.4 2.1 19.8 3.3 15.7 10.2 31.1 14.4 40.6.7 1.6 1.4 3 1.9 4.3 5 11.5 5.6 15.4 5.6 17.1 0 5.3-1.9 9.5-3.8 11.8-.9 1.1-1.6 1.6-2 1.8-.3.2-.8.3-1.6.4-2.9.1-5.7.2-8.6.2-114.9 0-208-93.1-208-208S141.1 48 256 48s208 93.1 208 208zm48 .5V256C512 114.6 397.4 0 256 0S0 114.6 0 256s114.6 256 256 256c3.5 0 7.1-.1 10.6-.2 31.8-1.3 53.4-30.1 53.4-62 0-14.5-6.1-28.3-12.1-42-4.3-9.8-8.7-19.7-10.8-29.9-.7-3.2-1-6.5-1-9.9 0-26.5 21.5-48 48-48H442c36.5 0 69.7-24.8 70.1-61.3zM160 256a32 32 0 10-64 0 32 32 0 1064 0zm0-64a32 32 0 100-64 32 32 0 100 64zm128-64a32 32 0 10-64 0 32 32 0 1064 0zm64 64a32 32 0 100-64 32 32 0 100 64z"}})])
          )
        }
      }
    